import { HeadingSection, HFlow, InfoLabel, Text, VFlow } from 'bold-ui'
import { booleanToSimNaoTitleCase } from 'components/form'
import theme from 'config/theme'
import { css } from 'emotion'
import { BeneficioDbEnum, InformacoesSocioEconomicas } from 'graphql/types.generated'
import { isObjectDeepEmpty } from 'util/object'
import { formatBeneficios } from 'view/cidadao/utils-cidadao'

interface InformacoesSocioeconomicasSectionProps {
  informacoesSocioeconomicas: InformacoesSocioEconomicas
  readonly beneficios?: readonly BeneficioDbEnum[] | null
}

export const InformacoesSocioeconomicasSection = (props: InformacoesSocioeconomicasSectionProps) => {
  const { informacoesSocioeconomicas, beneficios } = props

  const { id: _id, __typename, ...rest } = informacoesSocioeconomicas ?? {}
  const isInformacoesSocioeconomicasVazio = isObjectDeepEmpty(rest)
  const isBeneficiosVazio = !(!!beneficios && beneficios.length > 0)

  if (isInformacoesSocioeconomicasVazio && isBeneficiosVazio)
    return (
      <HeadingSection level={2} title='Informações socioeconômicas'>
        <Text fontStyle='italic'>Sem informações registradas</Text>
      </HeadingSection>
    )

  return (
    <HeadingSection level={2} title='Informações socioeconômicas'>
      <VFlow>
        {!isBeneficiosVazio && (
          <InfoLabel placeholder='-' title='Benefícios do governo'>
            {formatBeneficios([...beneficios!])}
          </InfoLabel>
        )}
        {!isInformacoesSocioeconomicasVazio && (
          <VFlow vSpacing={0}>
            <div className={styles.box}>
              <Text fontWeight='bold' fontSize={1}>
                TRIA
              </Text>
            </div>
            <HFlow style={styles.container} hSpacing={2}>
              <InfoLabel title='Nos últimos três meses, os alimentos acabaram antes que tivesse dinheiro para comprar mais comida'>
                {booleanToSimNaoTitleCase(
                  informacoesSocioeconomicas.statusAlimentosAcabaramAntesTerDinheiroComprarMais
                )}
              </InfoLabel>
              <InfoLabel title='Nos últimos três meses, comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou'>
                {booleanToSimNaoTitleCase(informacoesSocioeconomicas.statusComeuAlgunsAlimentosQueTinhaDinheiroAcabou)}
              </InfoLabel>
            </HFlow>
          </VFlow>
        )}
      </VFlow>
    </HeadingSection>
  )
}

const styles = {
  container: css`
    border: 1px solid ${theme.pallete.gray.c90};
    padding: 1.5rem;
    margin-right: 20rem;
  `,
  box: css`
    background-color: ${theme.pallete.gray.c90};
    padding: 0.8rem;
    margin-right: 20rem;
  `,
}
